/**
 * Centralized API configuration
 * All API base URLs should be imported from here
 */

// Determine the API base URL based on environment
// Priority: 1. Environment variable, 2. Relative path for production, 3. Localhost for development
export const API_BASE_URL = (() => {
  // If environment variable is set, use it
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  // In production, use relative path
  if (process.env.NODE_ENV === 'production') {
    return '/backend';
  }
  
  // Default to localhost for development
  return 'http://localhost:8000';
})();

// Helper function to build API endpoint URLs
export const getApiUrl = (endpoint: string): string => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  // Remove trailing slash from base URL if present
  const cleanBaseUrl = API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
  return `${cleanBaseUrl}/${cleanEndpoint}`;
};

